export default __webpack_public_path__ + "static/media/fleet-group.950b4cec.svg";